// extracted by mini-css-extract-plugin
export default {"header":"root_header__hl-6r","body":"root_body__QflfF"};